const typography = {
  fontFamily:
    '"Inter var", Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

  body1: {
    fontWeight: 450,
    lineHeight: 1.55,
  },
  body2: {
    fontWeight: 450,
    lineHeight: 1.5,
    fontFeatureSettings: '"tnum","kern"',
  },

  caption: {
    fontSize: '0.78rem', // ~12.5–13px
    fontWeight: 500,
    letterSpacing: '0.01em',
    fontFeatureSettings: '"tnum","kern"',
  },
  overline: {
    textTransform: 'none',
    fontSize: '0.75rem',
    fontWeight: 550,
    letterSpacing: '0.04em',
  },

  h6: { fontWeight: 550 },
  h5: { fontWeight: 550 },
  h4: { fontWeight: 520 },

  button: { textTransform: 'none', fontWeight: 600 },
};

export default typography;